

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// clearCart
// CLEARCART
const CLEARCART= createAsyncThunk(
  "clearCart/clearCart",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const clearCartSlice = createSlice({
  name: "clearCartSlice",
  initialState: {
    clearCart: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfclearCart: (state) => {
        state.clearCart.loading = false
        state.clearCart.error = false
        state.clearCart.data = []
        state.clearCart.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CLEARCART.fulfilled, (state, action) => {
      state.clearCart = {
        ...state.clearCart,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CLEARCART.pending, (state, action) => {
      state.clearCart = {
        ...state.clearCart,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CLEARCART.rejected, (state, action) => {
      state.clearCart = {
        ...state.clearCart,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const clearCartAction = {
    CLEARCART,
};

export { clearCartAction };
export default clearCartSlice.reducer;
export const {setInitialStateOfclearCart} = clearCartSlice.actions
